<template>
  <component :is="blockComponent[source.type]" :children="source.children"></component>
</template>
<script>
import { blockComponent } from "../utils/utils";
export default {
  name: "code-block",
  props: {
    children: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      blockComponent,
    };
  },
  computed: {
    elements() {
      return this.children.blockAttr.code.elements || [];
    },
    source() {
      let str = "";
      for (let i = 0; i < this.elements.length; i++) {
        str += this.elements[i].text_run.content;
      }
      let [type, url, attr] = str.split("\n");
      if (attr) {
        var [width, height, align] = attr.split(",");
      }
      return {
        type: this.getType(type),
        children: {
          blockAttr: {
            proxy: 1,
            image: {
              height: height,
              width: width,
              align: align,
              url:url,
            },
          },
        },
      };
    },
  },
  methods: {
    getType(type) {
      if (type === "toImage") {
        return 27;
      }
      return -1;
    },
  },
};
</script>